export default {
  default: () => import("/home/runner/work/doxa-frontend/doxa-frontend/layouts/default.vue")
}